// import React, { useEffect, useState, useMemo } from 'react';
// import { 
//   ShoppingBag, 
//   TrendingUp, 
//   TrendingDown, 
//   Box, 
//   CheckCircle, 
//   XCircle, 
//   Search, 
//   Filter, 
//   ArrowUpDown, 
//   MoreHorizontal,
//   Shirt,
//   Calendar,
//   CreditCard
// } from 'lucide-react';
// import Pagination from '../helpers/Pagination';
// import summaryApi from '../common/SummaryApi'; 
// import api from '../common/apiClient';

// const AllOrder = () => {
//   // --- State Management ---
//   const [allOrders, setAllOrders] = useState([]); // Stores ALL fetched data
//   const [filteredOrders, setFilteredOrders] = useState([]); // Stores data after Search/Tab filter
//   const [currentOrders, setCurrentOrders] = useState([]); // Stores data for current Page slice
  
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10); // UI Limit per page
  
//   const [activeTab, setActiveTab] = useState('All');
//   const [searchQuery, setSearchQuery] = useState('');

//   // --- 1. Fetch Data (Single Fetch Strategy) ---
//   const fetchAllOrders = async () => {
//     try {
//       setLoading(true);
      
//       // Requesting a high limit to get "All Data" in one go as requested
//       // In a real huge DB, you might need to handle this differently, but for this requirement:
//       const response = await api({
//         url: summaryApi.getAllOrders.url,
//         method: summaryApi.getAllOrders.method,
//         params: {
//           page: 1,
//           limit: 1000, // Fetching all available orders to handle pagination locally
//           status: ''   // Fetch all statuses
//         },
//         withCredentials: true
//       });

//       if (response.data.success) {
//         setAllOrders(response.data.orders);
//         setFilteredOrders(response.data.orders); // Initially, filtered is same as all
//       }
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllOrders();
//   }, []);

//   // --- 2. Dynamic Statistics Calculation ---
//   // Calculates stats based on the 'allOrders' data
//   const stats = useMemo(() => {
//     const total = allOrders.length;
//     const completed = allOrders.filter(o => o.status === 'PAID').length;
//     const pending = allOrders.filter(o => o.status === 'PAYMENT_PENDING').length;
//     const canceled = allOrders.filter(o => o.status === 'FAILED' || o.status === 'CANCELLED').length;
    
//     // Logic for "New Orders" (e.g., created in last 7 days)
//     const sevenDaysAgo = new Date();
//     sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//     const newOrders = allOrders.filter(o => new Date(o.createdAt) > sevenDaysAgo).length;

//     return [
//       { title: 'Total Orders', value: total, change: '+12%', isPositive: true, icon: Box, color: 'text-blue-600' },
//       { title: 'New Orders', value: newOrders, change: '+5%', isPositive: true, icon: ShoppingBag, color: 'text-orange-500' },
//       { title: 'Completed', value: completed, change: 'High', isPositive: true, icon: CheckCircle, color: 'text-green-600' },
//       { title: 'Canceled', value: canceled, change: '-2%', isPositive: false, icon: XCircle, color: 'text-red-500' },
//     ];
//   }, [allOrders]);

//   // --- 3. Filtering Logic (Tabs + Search) ---
//   useEffect(() => {
//     let result = [...allOrders];

//     // A. Filter by Tab Status
//     if (activeTab !== 'All') {
//       const statusMap = {
//         'Completed': 'PAID',
//         'Pending': 'PAYMENT_PENDING',
//         'Canceled': 'FAILED' // Or whatever your failure string is
//       };
//       result = result.filter(order => order.status === statusMap[activeTab]);
//     }

//     // B. Filter by Search Query
//     if (searchQuery) {
//       const lowerQuery = searchQuery.toLowerCase();
//       result = result.filter(order => 
//         order._id.toLowerCase().includes(lowerQuery) ||
//         order.customerInfo?.name?.toLowerCase().includes(lowerQuery) ||
//         order.customerInfo?.email?.toLowerCase().includes(lowerQuery) ||
//         order.totalAmount.toString().includes(lowerQuery)
//       );
//     }

//     setFilteredOrders(result);
//     setCurrentPage(1); // Reset to page 1 when filters change
//   }, [allOrders, activeTab, searchQuery]);

//   // --- 4. Pagination Logic (Slicing Data) ---
//   useEffect(() => {
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentSlice = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//     setCurrentOrders(currentSlice);
//   }, [filteredOrders, currentPage, itemsPerPage]);


//   // --- Helper Functions ---
//   const formatPrice = (price) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);
  
//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
//   };

//   const getStatusConfig = (status) => {
//     switch (status) {
//       case 'PAID': return { label: 'Delivered', color: 'text-green-500', bg: 'bg-green-100', icon: CheckCircle };
//       case 'PAYMENT_PENDING': return { label: 'Pending', color: 'text-orange-500', bg: 'bg-orange-100', icon: Box };
//       case 'FAILED': return { label: 'Cancelled', color: 'text-red-500', bg: 'bg-red-100', icon: XCircle };
//       default: return { label: status, color: 'text-gray-500', bg: 'bg-gray-100', icon: Box };
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-6 font-sans">
      
//       {/* HEADER */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
//         <h1 className="text-2xl font-bold text-gray-800">Order List</h1>
//         <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-colors shadow-lg shadow-blue-200 active:scale-95">
//           <span className="text-lg">+</span> Add Order
//         </button>
//       </div>

//       {/* STATS CARDS (Dynamic) */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//         {stats.map((stat, index) => (
//           <div key={index} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
//             <div className="flex justify-between items-start mb-4">
//               <div>
//                 <h3 className="text-sm font-medium text-gray-500">{stat.title}</h3>
//                 <div className="text-2xl font-bold text-gray-800 mt-1">{stat.value}</div>
//               </div>
//               <div className="p-2 bg-gray-50 rounded-lg">
//                 <MoreHorizontal size={16} className="text-gray-400" />
//               </div>
//             </div>
//             <div className="flex items-center text-xs font-medium">
//               <span className={`flex items-center gap-1 ${stat.isPositive ? 'text-green-500' : 'text-red-500'}`}>
//                 {stat.isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
//                 {stat.change}
//               </span>
//               <span className="text-gray-400 ml-2">Last 7 days</span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* FILTERS & SEARCH */}
//       <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-6 bg-transparent">
//         {/* Status Tabs */}
//         <div className="flex bg-gray-200/50 p-1 rounded-xl w-full lg:w-auto overflow-x-auto no-scrollbar">
//           {['All', 'Completed', 'Pending', 'Canceled'].map((tab) => (
//             <button
//               key={tab}
//               onClick={() => setActiveTab(tab)}
//               className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
//                 activeTab === tab
//                   ? 'bg-white text-blue-600 shadow-sm'
//                   : 'text-gray-500 hover:text-gray-700'
//               }`}
//             >
//               {tab === 'All' ? 'All Order' : tab} 
//               {tab === 'All' && <span className="ml-1 text-xs opacity-70">({allOrders.length})</span>}
//             </button>
//           ))}
//         </div>

//         {/* Search Bar */}
//         <div className="flex items-center gap-2 w-full lg:w-auto">
//           <div className="relative flex-1 lg:w-64">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
//             <input 
//               type="text" 
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               placeholder="Search by ID, Name..." 
//               className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 transition-all placeholder:text-gray-400"
//             />
//           </div>
//           <button className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 transition-colors">
//             <Filter size={18} />
//           </button>
//           <button className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 transition-colors">
//             <ArrowUpDown size={18} />
//           </button>
//         </div>
//       </div>

//       {/* DATA TABLE */}
//       <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-6 flex-1 flex flex-col">
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[1000px] border-collapse">
//             <thead>
//               <tr className="bg-blue-600 text-white text-left text-xs uppercase tracking-wider">
//                 <th className="p-4 w-16 text-center">No.</th>
//                 <th className="p-4 font-semibold">Order Id</th>
//                 <th className="p-4 font-semibold w-1/4">Product</th>
//                 <th className="p-4 font-semibold">Date</th>
//                 <th className="p-4 font-semibold">Price</th>
//                 <th className="p-4 font-semibold">Payment</th>
//                 <th className="p-4 font-semibold">Status</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-100">
//               {loading ? (
//                 <tr><td colSpan="7" className="p-10 text-center text-gray-500 animate-pulse">Fetching orders...</td></tr>
//               ) : currentOrders.length === 0 ? (
//                 <tr>
//                    <td colSpan="7" className="p-10 text-center text-gray-500 flex flex-col items-center justify-center">
//                       <div className="bg-gray-100 p-4 rounded-full mb-2"><Search size={24} className="text-gray-400"/></div>
//                       No orders found matching your criteria.
//                    </td>
//                 </tr>
//               ) : (
//                 currentOrders.map((order, index) => {
//                   const statusConfig = getStatusConfig(order.status);
//                   const StatusIcon = statusConfig.icon;
                  
//                   // Product Logic: Handle JSON structure (items array)
//                   // Note: Your provided JSON only has productId (string), no populated name.
//                   // I added a fallback. If you populate properly in backend, change 'Product Item' to item.productId.productName
//                   const primaryItem = order.items?.[0];
//                   const otherItemsCount = order.items?.length - 1;
//                   const displayProductName = "Product Item"; // Placeholder since JSON lacks name
                  
//                   return (
//                     <tr key={order._id} className="hover:bg-blue-50/50 transition-colors text-sm text-gray-700 group">
                      
//                       {/* 1. Sequence Number */}
//                       <td className="p-4 text-center">
//                         <span className="text-gray-400 font-bold text-xs">
//                           {(currentPage - 1) * itemsPerPage + index + 1}
//                         </span>
//                       </td>

//                       {/* 2. Order ID */}
//                       <td className="p-4">
//                          <span className="font-semibold text-gray-900 font-mono">
//                             #{order._id.slice(-6).toUpperCase()}
//                          </span>
//                          <div className="text-[10px] text-gray-400 mt-0.5">{order.customerInfo?.name || "Guest"}</div>
//                       </td>

//                       {/* 3. Product Details */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-3">
//                           <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center text-gray-400 group-hover:bg-white group-hover:shadow-sm transition-all border border-transparent group-hover:border-gray-200">
//                             <Shirt size={18} />
//                           </div>
//                           <div>
//                             <div className="font-semibold text-gray-900">{displayProductName}</div>
//                             <div className="flex items-center gap-2 mt-0.5">
//                                 <span className="text-[11px] text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded">
//                                     Qty: {primaryItem?.quantity || 1}
//                                 </span>
//                                 {/* Badge for multiple products */}
//                                 {otherItemsCount > 0 && (
//                                     <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded">
//                                         +{otherItemsCount} others
//                                     </span>
//                                 )}
//                             </div>
//                           </div>
//                         </div>
//                       </td>

//                       {/* 4. Date */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-2 text-gray-500">
//                             <Calendar size={14} className="text-gray-400"/>
//                             <span className="font-medium">{formatDate(order.createdAt)}</span>
//                         </div>
//                       </td>

//                       {/* 5. Price */}
//                       <td className="p-4">
//                         <span className="font-bold text-gray-900 tracking-tight">
//                             {formatPrice(order.totalAmount)}
//                         </span>
//                       </td>

//                       {/* 6. Payment Status */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-2">
//                             <div className={`w-2 h-2 rounded-full ${order.status === 'PAID' ? 'bg-green-500' : 'bg-red-500'}`}></div>
//                             <span className={`font-semibold text-xs ${order.status === 'PAID' ? 'text-green-700' : 'text-red-500'}`}>
//                                 {order.status === 'PAID' ? 'Paid' : 'Unpaid'}
//                             </span>
//                         </div>
//                       </td>

//                       {/* 7. Fulfillment Status */}
//                       <td className="p-4">
//                         <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold border ${statusConfig.bg} ${statusConfig.color} border-transparent bg-opacity-70`}>
//                           <StatusIcon size={14} />
//                           {statusConfig.label}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* FOOTER: PAGINATION */}
//       {/* Passing filtered length so pagination calculates pages based on search results */}
//       <Pagination 
//         totalItems={filteredOrders.length} 
//         itemsPerPage={itemsPerPage} 
//         currentPage={currentPage} 
//         onPageChange={setCurrentPage} 
//       />

//     </div>
//   );
// };

// export default AllOrder;


// import React, { useEffect, useState, useMemo } from 'react';
// import { 
//   ShoppingBag, 
//   TrendingUp, 
//   TrendingDown, 
//   Box, 
//   CheckCircle, 
//   XCircle, 
//   Search, 
//   Filter, 
//   ArrowUpDown, 
//   MoreHorizontal,
//   Calendar,
//   ImageOff // For missing images
// } from 'lucide-react';
// import { useNavigate } from 'react-router-dom'; // Navigation hook
// import Pagination from '../helpers/Pagination';
// import summaryApi from '../common/SummaryApi'; 
// import api from '../common/apiClient';

// const AllOrder = () => {
//   const navigate = useNavigate(); // For row click navigation

//   // --- State Management ---
//   const [allOrders, setAllOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [currentOrders, setCurrentOrders] = useState([]);
  
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
  
//   const [activeTab, setActiveTab] = useState('All');
//   const [searchQuery, setSearchQuery] = useState('');

//   // --- 1. Fetch Data ---
//   const fetchAllOrders = async () => {
//     try {
//       setLoading(true);
//       const response = await api({
//         url: summaryApi.getAllOrders.url,
//         method: summaryApi.getAllOrders.method,
//         params: {
//           page: 1,
//           limit: 1000, 
//           status: ''
//         },
//         withCredentials: true
//       });

//       if (response.data.success) {
//         setAllOrders(response.data.orders);
//         setFilteredOrders(response.data.orders);
//       }
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllOrders();
//   }, []);

//   // --- 2. Stats Calculation ---
//   const stats = useMemo(() => {
//     const total = allOrders.length;
//     const completed = allOrders.filter(o => o.status === 'PAID').length;
//     // const pending = allOrders.filter(o => o.status === 'PAYMENT_PENDING').length;
//     const canceled = allOrders.filter(o => o.status === 'FAILED' || o.status === 'CANCELLED').length;
    
//     const sevenDaysAgo = new Date();
//     sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//     const newOrders = allOrders.filter(o => new Date(o.createdAt) > sevenDaysAgo).length;

//     return [
//       { title: 'Total Orders', value: total, change: '+12%', isPositive: true, icon: Box, color: 'text-blue-600' },
//       { title: 'New Orders', value: newOrders, change: '+5%', isPositive: true, icon: ShoppingBag, color: 'text-orange-500' },
//       { title: 'Completed', value: completed, change: 'High', isPositive: true, icon: CheckCircle, color: 'text-green-600' },
//       { title: 'Canceled', value: canceled, change: '-2%', isPositive: false, icon: XCircle, color: 'text-red-500' },
//     ];
//   }, [allOrders]);

//   // --- 3. Filtering Logic (Updated for Razorpay ID) ---
//   useEffect(() => {
//     let result = [...allOrders];

//     // A. Tab Filter
//     if (activeTab !== 'All') {
//       const statusMap = {
//         'Completed': 'PAID',
//         'Pending': 'PAYMENT_PENDING',
//         'Canceled': 'FAILED'
//       };
//       result = result.filter(order => order.status === statusMap[activeTab]);
//     }

//     // B. Search Filter (Updated)
//     if (searchQuery) {
//       const lowerQuery = searchQuery.toLowerCase();
//       result = result.filter(order => 
//         // 1. Search by Razorpay Order ID
//         (order.razorpayOrderId && order.razorpayOrderId.toLowerCase().includes(lowerQuery)) ||
//         // 2. Search by Customer Name
//         (order.customerInfo?.name && order.customerInfo.name.toLowerCase().includes(lowerQuery)) ||
//         // 3. Search by Amount
//         order.totalAmount.toString().includes(lowerQuery)
//       );
//     }

//     setFilteredOrders(result);
//     setCurrentPage(1); 
//   }, [allOrders, activeTab, searchQuery]);

//   // --- 4. Pagination Slice ---
//   useEffect(() => {
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     setCurrentOrders(filteredOrders.slice(indexOfFirstItem, indexOfLastItem));
//   }, [filteredOrders, currentPage, itemsPerPage]);


//   // --- Helper Functions ---
//   const formatPrice = (price) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);
  
//   const formatDate = (dateString) => {
//     if(!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
//   };

//   const getStatusConfig = (status) => {
//     switch (status) {
//       case 'PAID': return { label: 'Delivered', color: 'text-green-600', bg: 'bg-green-100', icon: CheckCircle };
//       case 'PAYMENT_PENDING': return { label: 'Pending', color: 'text-orange-600', bg: 'bg-orange-100', icon: Box };
//       case 'FAILED': return { label: 'Cancelled', color: 'text-red-600', bg: 'bg-red-100', icon: XCircle };
//       default: return { label: status, color: 'text-gray-600', bg: 'bg-gray-100', icon: Box };
//     }
//   };

//   // --- Navigate to Single Order ---
//   const handleRowClick = (orderId) => {
//     // Navigating using MongoDB ID usually, but you can use Razorpay ID if your route supports it
//     navigate(`/admin-panel/all-orders/${orderId}`); 
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-6 font-sans">
      
//       {/* HEADER */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
//         <h1 className="text-2xl font-bold text-gray-800">Order List</h1>
//         <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-colors shadow-lg shadow-blue-200 active:scale-95">
//           <span className="text-lg">+</span> Add Order
//         </button>
//       </div>

//       {/* STATS CARDS */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//         {stats.map((stat, index) => (
//           <div key={index} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
//             <div className="flex justify-between items-start mb-4">
//               <div>
//                 <h3 className="text-sm font-medium text-gray-500">{stat.title}</h3>
//                 <div className="text-2xl font-bold text-gray-800 mt-1">{stat.value}</div>
//               </div>
//               <div className="p-2 bg-gray-50 rounded-lg">
//                 <MoreHorizontal size={16} className="text-gray-400" />
//               </div>
//             </div>
//             <div className="flex items-center text-xs font-medium">
//               <span className={`flex items-center gap-1 ${stat.isPositive ? 'text-green-500' : 'text-red-500'}`}>
//                 {stat.isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
//                 {stat.change}
//               </span>
//               <span className="text-gray-400 ml-2">Last 7 days</span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* FILTERS & SEARCH */}
//       <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-6 bg-transparent">
//         <div className="flex bg-gray-200/50 p-1 rounded-xl w-full lg:w-auto overflow-x-auto no-scrollbar">
//           {['All', 'Completed', 'Pending', 'Canceled'].map((tab) => (
//             <button
//               key={tab}
//               onClick={() => setActiveTab(tab)}
//               className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
//                 activeTab === tab
//                   ? 'bg-white text-blue-600 shadow-sm'
//                   : 'text-gray-500 hover:text-gray-700'
//               }`}
//             >
//               {tab === 'All' ? 'All Order' : tab} 
//               {tab === 'All' && <span className="ml-1 text-xs opacity-70">({allOrders.length})</span>}
//             </button>
//           ))}
//         </div>

//         <div className="flex items-center gap-2 w-full lg:w-auto">
//           <div className="relative flex-1 lg:w-64">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
//             <input 
//               type="text" 
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               placeholder="Search ID, Name..." 
//               className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 transition-all placeholder:text-gray-400"
//             />
//           </div>
//           <button className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 transition-colors">
//             <Filter size={18} />
//           </button>
//           <button className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 transition-colors">
//             <ArrowUpDown size={18} />
//           </button>
//         </div>
//       </div>

//       {/* DATA TABLE */}
//       <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-6 flex-1 flex flex-col min-h-[400px]">
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[1000px] border-collapse">
//             <thead>
//               <tr className="bg-blue-600 text-white text-left text-xs uppercase tracking-wider">
//                 <th className="p-4 w-16 text-center">No.</th>
//                 <th className="p-4 font-semibold">Order Id</th>
//                 <th className="p-4 font-semibold w-1/4">Product</th>
//                 <th className="p-4 font-semibold">Date</th>
//                 <th className="p-4 font-semibold">Price</th>
//                 <th className="p-4 font-semibold">Payment</th>
//                 <th className="p-4 font-semibold">Status</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-100">
//               {loading ? (
//                 <tr>
//                     <td colSpan="7" className="p-10 text-center text-gray-500">
//                         <div className="flex justify-center items-center gap-2 animate-pulse">
//                             <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
//                             <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-100"></div>
//                             <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-200"></div>
//                             Loading orders...
//                         </div>
//                     </td>
//                 </tr>
//               ) : currentOrders.length === 0 ? (
//                 // --- NO ORDERS FOUND UI (FIXED) ---
//                 <tr>
//                    <td colSpan="7">
//                       <div className="flex flex-col items-center justify-center py-20 text-gray-400">
//                           <div className="bg-gray-50 p-6 rounded-full mb-4 shadow-inner">
//                             <Search size={40} className="text-gray-300"/>
//                           </div>
//                           <h3 className="text-lg font-semibold text-gray-600">No Orders Found</h3>
//                           <p className="text-sm text-gray-400 mt-1">
//                             We couldn't find any orders matching "{searchQuery}"
//                           </p>
//                           <button 
//                             onClick={() => {setSearchQuery(''); setActiveTab('All')}}
//                             className="mt-4 px-4 py-2 bg-blue-50 text-blue-600 text-sm font-medium rounded-lg hover:bg-blue-100 transition-colors"
//                           >
//                             Clear Filters
//                           </button>
//                       </div>
//                    </td>
//                 </tr>
//               ) : (
//                 currentOrders.map((order, index) => {
//                   const statusConfig = getStatusConfig(order.status);
//                   const StatusIcon = statusConfig.icon;
                  
//                   // --- Product Info Logic ---
//                   const primaryItem = order.items?.[0];
//                   // Safe check if productId is populated object or just ID string
//                   const isPopulated = primaryItem?.productId && typeof primaryItem.productId === 'object';
                  
//                   const productName = isPopulated 
//                         ? primaryItem.productId.productName 
//                         : "Product Name Unavailable"; // Fallback if backend didn't populate

//                   const productImage = isPopulated && primaryItem.productId.productImage?.length > 0 
//                         ? primaryItem.productId.productImage[0] 
//                         : null;

//                   const otherItemsCount = order.items?.length - 1;
                  
//                   return (
//                     <tr 
//                         key={order._id} 
//                         onClick={() => handleRowClick(order._id)} // Navigate on Click
//                         className="hover:bg-blue-50/50 transition-colors text-sm text-gray-700 cursor-pointer group"
//                     >
                      
//                       {/* 1. No */}
//                       <td className="p-4 text-center">
//                         <span className="text-gray-400 font-bold text-xs">
//                           {(currentPage - 1) * itemsPerPage + index + 1}
//                         </span>
//                       </td>

//                       {/* 2. Razorpay Order ID (Requested) */}
//                       <td className="p-4">
//                          <span className="font-semibold text-gray-900 font-mono text-xs sm:text-sm">
//                             {order.razorpayOrderId || "N/A"}
//                          </span>
//                          <div className="text-[10px] text-gray-400 mt-0.5">{order.customerInfo?.name || "Guest"}</div>
//                       </td>

//                       {/* 3. Product Display (Image + Name) */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-3">
//                           {/* Image Box */}
//                           <div className="w-10 h-10 rounded-lg bg-gray-100 flex-shrink-0 flex items-center justify-center text-gray-400 overflow-hidden border border-gray-200">
//                              {productImage ? (
//                                 <img src={productImage} alt="Product" className="w-full h-full object-cover" />
//                              ) : (
//                                 <ImageOff size={16} /> // Icon if no image
//                              )}
//                           </div>
                          
//                           {/* Name & Quantity */}
//                           <div>
//                             <div className="font-semibold text-gray-900 line-clamp-1 max-w-[200px]" title={productName}>
//                                 {productName}
//                             </div>
//                             <div className="flex items-center gap-2 mt-0.5">
//                                 <span className="text-[11px] text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded">
//                                     Qty: {primaryItem?.quantity || 1}
//                                 </span>
//                                 {otherItemsCount > 0 && (
//                                     <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded border border-blue-100">
//                                         +{otherItemsCount} more
//                                     </span>
//                                 )}
//                             </div>
//                           </div>
//                         </div>
//                       </td>

//                       {/* 4. Date */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-2 text-gray-500">
//                             <Calendar size={14} className="text-gray-400"/>
//                             <span className="font-medium whitespace-nowrap">{formatDate(order.createdAt)}</span>
//                         </div>
//                       </td>

//                       {/* 5. Price */}
//                       <td className="p-4">
//                         <span className="font-bold text-gray-900 tracking-tight">
//                             {formatPrice(order.totalAmount)}
//                         </span>
//                       </td>

//                       {/* 6. Payment Badge */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-2">
//                             <div className={`w-2 h-2 rounded-full ${order.status === 'PAID' ? 'bg-green-500' : 'bg-red-500'}`}></div>
//                             <span className={`font-semibold text-xs ${order.status === 'PAID' ? 'text-green-700' : 'text-red-500'}`}>
//                                 {order.status === 'PAID' ? 'Paid' : 'Unpaid'}
//                             </span>
//                         </div>
//                       </td>

//                       {/* 7. Status Badge */}
//                       <td className="p-4">
//                         <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold border ${statusConfig.bg} ${statusConfig.color} border-transparent bg-opacity-70`}>
//                           <StatusIcon size={14} />
//                           {statusConfig.label}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* FOOTER: PAGINATION */}
//       <Pagination 
//         totalItems={filteredOrders.length} 
//         itemsPerPage={itemsPerPage} 
//         currentPage={currentPage} 
//         onPageChange={setCurrentPage} 
//       />

//     </div>
//   );
// };

// export default AllOrder;

// import React, { useEffect, useState, useMemo } from 'react';
// import { 
//   ShoppingBag, 
//   TrendingUp, 
//   TrendingDown, 
//   Box, 
//   CheckCircle, 
//   XCircle, 
//   Search, 
//   Filter, 
//   ArrowUpDown, 
//   MoreHorizontal,
//   Shirt,
//   Calendar,
//   ImageOff,
//   Download // Icon for Export
// } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { saveAs } from 'file-saver'; // Install: npm install file-saver
// import Pagination from '../helpers/Pagination';
// import summaryApi from '../common/SummaryApi'; 
// import api from '../common/apiClient';

// const AllOrder = () => {
//   const navigate = useNavigate();

//   // --- State Management ---
//   const [allOrders, setAllOrders] = useState([]); // Master Data
//   const [filteredOrders, setFilteredOrders] = useState([]); // Display Data
//   const [currentOrders, setCurrentOrders] = useState([]); // Pagination Slice
  
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
  
//   // Filters
//   const [activeTab, setActiveTab] = useState('All');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');

//   // --- 1. Fetch Data (Single Fetch) ---
//   const fetchAllOrders = async () => {
//     try {
//       setLoading(true);
//       const response = await api({
//         url: summaryApi.getAllOrders.url,
//         method: summaryApi.getAllOrders.method,
//         params: {
//           page: 1,
//           limit: 2000, // Fetching large dataset for client-side filtering
//           status: ''
//         },
//         withCredentials: true
//       });

//       if (response.data.success) {
//         setAllOrders(response.data.orders);
//         setFilteredOrders(response.data.orders);
//       }
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllOrders();
//   }, []);

//   // --- 2. Stats Calculation ---
//   const stats = useMemo(() => {
//     const total = allOrders.length;
//     const completed = allOrders.filter(o => o.status === 'PAID').length;
//     const canceled = allOrders.filter(o => o.status === 'FAILED' || o.status === 'CANCELLED').length;
    
//     const sevenDaysAgo = new Date();
//     sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//     const newOrders = allOrders.filter(o => new Date(o.createdAt) > sevenDaysAgo).length;

//     return [
//       { title: 'Total Orders', value: total, change: '+12%', isPositive: true, icon: Box, color: 'text-blue-600' },
//       { title: 'New Orders', value: newOrders, change: '+5%', isPositive: true, icon: ShoppingBag, color: 'text-orange-500' },
//       { title: 'Completed', value: completed, change: 'High', isPositive: true, icon: CheckCircle, color: 'text-green-600' },
//       { title: 'Canceled', value: canceled, change: '-2%', isPositive: false, icon: XCircle, color: 'text-red-500' },
//     ];
//   }, [allOrders]);

//   // --- 3. Master Filtering Logic (Tabs + Search + Date) ---
//   useEffect(() => {
//     let result = [...allOrders];

//     // A. Tab Filter (Status)
//     if (activeTab !== 'All') {
//       const statusMap = {
//         'Completed': 'PAID',
//         'Pending': 'PAYMENT_PENDING',
//         'Canceled': 'FAILED'
//       };
//       result = result.filter(order => order.status === statusMap[activeTab]);
//     }

//     // B. Date Range Filter
//     if (fromDate) {
//         const from = new Date(fromDate).setHours(0, 0, 0, 0);
//         result = result.filter(order => new Date(order.createdAt).setHours(0,0,0,0) >= from);
//     }
//     if (toDate) {
//         const to = new Date(toDate).setHours(23, 59, 59, 999);
//         result = result.filter(order => new Date(order.createdAt).getTime() <= to);
//     }

//     // C. Search Filter
//     if (searchQuery) {
//       const lowerQuery = searchQuery.toLowerCase();
//       result = result.filter(order => 
//         (order.razorpayOrderId && order.razorpayOrderId.toLowerCase().includes(lowerQuery)) ||
//         (order.customerInfo?.name && order.customerInfo.name.toLowerCase().includes(lowerQuery)) ||
//         order.totalAmount.toString().includes(lowerQuery)
//       );
//     }

//     setFilteredOrders(result);
//     setCurrentPage(1); 
//   }, [allOrders, activeTab, searchQuery, fromDate, toDate]);

//   // --- 4. Pagination Slice ---
//   useEffect(() => {
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     setCurrentOrders(filteredOrders.slice(indexOfFirstItem, indexOfLastItem));
//   }, [filteredOrders, currentPage, itemsPerPage]);

//   // --- 5. Export Functionality (From Reference) ---
//   const handleExport = () => {
//     if (filteredOrders.length === 0) return;

//     const csvContent = filteredOrders.map((item) => {
//         // Safe access helper
//         const primaryItem = item.items?.[0] || {};
//         const productName = primaryItem.productId?.productName || "N/A";

//         const row = [
//             item.razorpayOrderId || item._id, // Order ID
//             new Date(item.createdAt).toLocaleString(), // Date
//             item.status, // Status
//             item.customerInfo?.name || "Guest", // Customer Name
//             item.customerInfo?.email || "N/A", // Email
//             item.customerInfo?.phone || "N/A", // Phone
//             productName, // First Product
//             item.items?.length || 0, // Total Items count
//             item.totalAmount, // Total Amount
//             // Address Handling
//             item.shippingAddress?.city || "N/A",
//             item.shippingAddress?.state || "N/A",
//             item.shippingAddress?.pincode || "N/A"
//         ].join(",");
//         return row;
//     });

//     const header = [
//         "Order ID", "Date", "Status", "Customer Name", "Email", "Phone", 
//         "Product", "Total Items", "Amount", "City", "State", "Pincode"
//     ];

//     const csv = [header.join(",")].concat(csvContent).join("\n");
//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//     saveAs(blob, `orders_report_${new Date().toLocaleDateString()}.csv`);
//   };

//   // --- Helper Functions ---
//   const formatPrice = (price) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);
  
//   const formatDate = (dateString) => {
//     if(!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
//   };

//   const getStatusConfig = (status) => {
//     switch (status) {
//       case 'PAID': return { label: 'Delivered', color: 'text-green-600', bg: 'bg-green-100', icon: CheckCircle };
//       case 'PAYMENT_PENDING': return { label: 'Pending', color: 'text-orange-600', bg: 'bg-orange-100', icon: Box };
//       case 'FAILED': return { label: 'Cancelled', color: 'text-red-600', bg: 'bg-red-100', icon: XCircle };
//       default: return { label: status, color: 'text-gray-600', bg: 'bg-gray-100', icon: Box };
//     }
//   };

//   const handleRowClick = (orderId) => {
//     navigate(`/admin/order/${orderId}`); 
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-6 font-sans">
      
//       {/* HEADER */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
//         <h1 className="text-2xl font-bold text-gray-800">Order List</h1>
//         <div className="flex gap-3">
//             {/* Export Button */}
//             <button 
//                 onClick={handleExport}
//                 className="bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-colors shadow-sm"
//             >
//                 <Download size={16} />
//                 Export
//             </button>
//             {/* Add Order Button */}
//             <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-colors shadow-lg shadow-blue-200 active:scale-95">
//                 <span className="text-lg">+</span> Add Order
//             </button>
//         </div>
//       </div>

//       {/* STATS CARDS */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//         {stats.map((stat, index) => (
//           <div key={index} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
//             <div className="flex justify-between items-start mb-4">
//               <div>
//                 <h3 className="text-sm font-medium text-gray-500">{stat.title}</h3>
//                 <div className="text-2xl font-bold text-gray-800 mt-1">{stat.value}</div>
//               </div>
//               <div className="p-2 bg-gray-50 rounded-lg">
//                 <MoreHorizontal size={16} className="text-gray-400" />
//               </div>
//             </div>
//             <div className="flex items-center text-xs font-medium">
//               <span className={`flex items-center gap-1 ${stat.isPositive ? 'text-green-500' : 'text-red-500'}`}>
//                 {stat.isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
//                 {stat.change}
//               </span>
//               <span className="text-gray-400 ml-2">Last 7 days</span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* FILTERS & SEARCH & DATE */}
//       <div className="flex flex-col xl:flex-row justify-between items-center gap-4 mb-6 bg-transparent">
        
//         {/* Left: Status Tabs */}
//         <div className="flex bg-gray-200/50 p-1 rounded-xl w-full xl:w-auto overflow-x-auto no-scrollbar">
//           {['All', 'Completed', 'Pending', 'Canceled'].map((tab) => (
//             <button
//               key={tab}
//               onClick={() => setActiveTab(tab)}
//               className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
//                 activeTab === tab
//                   ? 'bg-white text-blue-600 shadow-sm'
//                   : 'text-gray-500 hover:text-gray-700'
//               }`}
//             >
//               {tab === 'All' ? 'All Order' : tab} 
//               {tab === 'All' && <span className="ml-1 text-xs opacity-70">({allOrders.length})</span>}
//             </button>
//           ))}
//         </div>

//         {/* Right: Date Range & Search */}
//         <div className="flex flex-col sm:flex-row items-center gap-2 w-full xl:w-auto">
            
//             {/* Date Inputs */}
//             <div className="flex items-center gap-2 w-full sm:w-auto">
//                 <div className="relative w-full sm:w-auto">
//                     <input 
//                         type="date" 
//                         value={fromDate}
//                         onChange={(e) => setFromDate(e.target.value)}
//                         className="w-full sm:w-36 px-3 py-2.5 bg-white border border-gray-200 rounded-xl text-xs text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
//                         placeholder="From"
//                     />
//                 </div>
//                 <span className="text-gray-400 text-xs">to</span>
//                 <div className="relative w-full sm:w-auto">
//                     <input 
//                         type="date" 
//                         value={toDate}
//                         onChange={(e) => setToDate(e.target.value)}
//                         className="w-full sm:w-36 px-3 py-2.5 bg-white border border-gray-200 rounded-xl text-xs text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
//                     />
//                 </div>
//             </div>

//             {/* Search Bar */}
//             <div className="relative flex-1 w-full sm:w-64">
//                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
//                 <input 
//                 type="text" 
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 placeholder="Search ID, Name..." 
//                 className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 transition-all placeholder:text-gray-400"
//                 />
//             </div>

//             {/* Icons */}
//             <div className="flex gap-2 hidden sm:flex">
//                 <button className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 transition-colors">
//                     <Filter size={18} />
//                 </button>
//             </div>
//         </div>
//       </div>

//       {/* DATA TABLE */}
//       <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-6 flex-1 flex flex-col min-h-[400px]">
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[1000px] border-collapse">
//             <thead>
//               <tr className="bg-blue-600 text-white text-left text-xs uppercase tracking-wider">
//                 <th className="p-4 w-16 text-center">No.</th>
//                 <th className="p-4 font-semibold">Order Id</th>
//                 <th className="p-4 font-semibold w-1/4">Product</th>
//                 <th className="p-4 font-semibold">Date</th>
//                 <th className="p-4 font-semibold">Price</th>
//                 <th className="p-4 font-semibold">Payment</th>
//                 <th className="p-4 font-semibold">Status</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-100">
//               {loading ? (
//                 <tr>
//                     <td colSpan="7" className="p-10 text-center text-gray-500">
//                         <div className="flex justify-center items-center gap-2 animate-pulse">
//                             <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
//                             <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-100"></div>
//                             <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-200"></div>
//                             Loading orders...
//                         </div>
//                     </td>
//                 </tr>
//               ) : currentOrders.length === 0 ? (
//                 <tr>
//                    <td colSpan="7">
//                       <div className="flex flex-col items-center justify-center py-20 text-gray-400">
//                           <div className="bg-gray-50 p-6 rounded-full mb-4 shadow-inner">
//                             <Search size={40} className="text-gray-300"/>
//                           </div>
//                           <h3 className="text-lg font-semibold text-gray-600">No Orders Found</h3>
//                           <p className="text-sm text-gray-400 mt-1">
//                             Try adjusting your filters or search criteria.
//                           </p>
//                           <button 
//                             onClick={() => {setSearchQuery(''); setActiveTab('All'); setFromDate(''); setToDate('')}}
//                             className="mt-4 px-4 py-2 bg-blue-50 text-blue-600 text-sm font-medium rounded-lg hover:bg-blue-100 transition-colors"
//                           >
//                             Clear All Filters
//                           </button>
//                       </div>
//                    </td>
//                 </tr>
//               ) : (
//                 currentOrders.map((order, index) => {
//                   const statusConfig = getStatusConfig(order.status);
//                   const StatusIcon = statusConfig.icon;
                  
//                   // Product Info Logic
//                   const primaryItem = order.items?.[0];
//                   const isPopulated = primaryItem?.productId && typeof primaryItem.productId === 'object';
                  
//                   const productName = isPopulated 
//                         ? primaryItem.productId.productName 
//                         : "Product Name Unavailable"; 

//                   const productImage = isPopulated && primaryItem.productId.productImage?.length > 0 
//                         ? primaryItem.productId.productImage[0] 
//                         : null;

//                   const otherItemsCount = order.items?.length - 1;
                  
//                   return (
//                     <tr 
//                         key={order._id} 
//                         onClick={() => handleRowClick(order._id)} 
//                         className="hover:bg-blue-50/50 transition-colors text-sm text-gray-700 cursor-pointer group"
//                     >
                      
//                       {/* No */}
//                       <td className="p-4 text-center">
//                         <span className="text-gray-400 font-bold text-xs">
//                           {(currentPage - 1) * itemsPerPage + index + 1}
//                         </span>
//                       </td>

//                       {/* Razorpay Order ID */}
//                       <td className="p-4">
//                          <span className="font-semibold text-gray-900 font-mono text-xs sm:text-sm">
//                             {order.razorpayOrderId || "N/A"}
//                          </span>
//                          <div className="text-[10px] text-gray-400 mt-0.5">{order.customerInfo?.name || "Guest"}</div>
//                       </td>

//                       {/* Product Display */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-3">
//                           <div className="w-10 h-10 rounded-lg bg-gray-100 flex-shrink-0 flex items-center justify-center text-gray-400 overflow-hidden border border-gray-200">
//                              {productImage ? (
//                                 <img src={productImage} alt="Product" className="w-full h-full object-cover" />
//                              ) : (
//                                 <ImageOff size={16} /> 
//                              )}
//                           </div>
                          
//                           <div>
//                             <div className="font-semibold text-gray-900 line-clamp-1 max-w-[200px]" title={productName}>
//                                 {productName}
//                             </div>
//                             <div className="flex items-center gap-2 mt-0.5">
//                                 <span className="text-[11px] text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded">
//                                     Qty: {primaryItem?.quantity || 1}
//                                 </span>
//                                 {otherItemsCount > 0 && (
//                                     <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded border border-blue-100">
//                                         +{otherItemsCount} more
//                                     </span>
//                                 )}
//                             </div>
//                           </div>
//                         </div>
//                       </td>

//                       {/* Date */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-2 text-gray-500">
//                             <Calendar size={14} className="text-gray-400"/>
//                             <span className="font-medium whitespace-nowrap">{formatDate(order.createdAt)}</span>
//                         </div>
//                       </td>

//                       {/* Price */}
//                       <td className="p-4">
//                         <span className="font-bold text-gray-900 tracking-tight">
//                             {formatPrice(order.totalAmount)}
//                         </span>
//                       </td>

//                       {/* Payment Badge */}
//                       <td className="p-4">
//                         <div className="flex items-center gap-2">
//                             <div className={`w-2 h-2 rounded-full ${order.status === 'PAID' ? 'bg-green-500' : 'bg-red-500'}`}></div>
//                             <span className={`font-semibold text-xs ${order.status === 'PAID' ? 'text-green-700' : 'text-red-500'}`}>
//                                 {order.status === 'PAID' ? 'Paid' : 'Unpaid'}
//                             </span>
//                         </div>
//                       </td>

//                       {/* Status Badge */}
//                       <td className="p-4">
//                         <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold border ${statusConfig.bg} ${statusConfig.color} border-transparent bg-opacity-70`}>
//                           <StatusIcon size={14} />
//                           {statusConfig.label}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* FOOTER: PAGINATION */}
//       <Pagination 
//         totalItems={filteredOrders.length} 
//         itemsPerPage={itemsPerPage} 
//         currentPage={currentPage} 
//         onPageChange={setCurrentPage} 
//       />

//     </div>
//   );
// };

// export default AllOrder;


// import React, { useEffect, useState, useMemo, useRef } from 'react';
// import { 
//   ShoppingBag, 
//   Box, 
//   CheckCircle, 
//   XCircle, 
//   Search, 
//   ListFilter
// } from 'lucide-react';
// import Pagination from '../helpers/Pagination';
// import summaryApi from '../common/SummaryApi'; 
// import api from '../common/apiClient';
// import OrderTable from "../panelComponents/DashboardComponent/OrderTable";
// import OrderStatsCard from '../panelComponents/DashboardComponent/OrderStatCard';
// import SelectDropdown from '../customStyles/SelectDropdown';
// import CustomDatePicker from '../customStyles/CustomDatePicker';
// import { RiArrowUpDownLine } from "react-icons/ri";
// import { FiMoreHorizontal } from "react-icons/fi";

// const AllOrder = ({showStats = true}) => {
//   // --- State Management ---
//   const [allOrders, setAllOrders] = useState([]); 
//   const [filteredOrders, setFilteredOrders] = useState([]); 
//   const [currentOrders, setCurrentOrders] = useState([]);  
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showFilter, setShowFilter] = useState(false);
//   const [showSort, setShowSort] = useState(false);
//   const [showPageModal, setShowPageModal] = useState(false);
//   const [orderStatus, setOrderStatus] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [sortOrder, setSortOrder] = useState(""); // newest | oldest
//   const filterWrapperRef = useRef(null);
  
//   // --- FILTERS STATE ---
//   const [activeTab, setActiveTab] = useState('All'); // Payment Status (Paid/Unpaid)
//   const [searchQuery, setSearchQuery] = useState('');

//   const orderStatusOptions = [
//     { id: "", label: "All Status" },
//     { id: "ordered", label: "Ordered" },
//     { id: "packaged", label: "Packaged" },
//     { id: "shipped", label: "Shipped" },
//     { id: "delivered", label: "Delivered" },
//     { id: "cancelled", label: "Cancelled" },
//   ];

//   const sortOptions = [
//     { id: "newest", label: "Newest first" },
//     { id: "oldest", label: "Oldest first" },
//   ];

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         filterWrapperRef.current &&
//         !filterWrapperRef.current.contains(e.target)
//       ) {
//         setShowFilter(false);
//         setShowSort(false);
//         setShowPageModal(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);


//   // --- 1. Fetch Data ---
//   const fetchAllOrders = async () => {
//     try {
//       setLoading(true);
//       const response = await api({
//         url: summaryApi.getAllOrders.url,
//         method: summaryApi.getAllOrders.method,
//         params: {
//           page: 1,
//           limit: 2000, 
//           status: ''
//         },
//         withCredentials: true
//       });

//       if (response.data.success) {
//         const duplicatedOrders = Array.from({ length: 100 }, () => response.data.orders).flat();

//         setAllOrders(duplicatedOrders);
//         // setAllOrders(response.data.orders);
//         setFilteredOrders(duplicatedOrders);
//       }
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllOrders();
//   }, []);

//   // --- 2. Stats Calculation ---
//   const stats = useMemo(() => {
//     const total = allOrders.length;
//     const completed = allOrders.filter(o => o.status === 'PAID').length;
//     const canceled = allOrders.filter(o => o.status === 'FAILED' || o.status === 'CANCELLED').length;
    
//     const sevenDaysAgo = new Date();
//     sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//     const newOrders = allOrders.filter(o => new Date(o.createdAt) > sevenDaysAgo).length;

//     return [
//       { title: 'Total Orders', value: total, change: '+12%', isPositive: true, icon: Box, color: 'text-blue-600' },
//       { title: 'New Orders', value: newOrders, change: '+5%', isPositive: true, icon: ShoppingBag, color: 'text-orange-500' },
//       { title: 'Completed', value: completed, change: 'High', isPositive: true, icon: CheckCircle, color: 'text-green-600' },
//       { title: 'Canceled', value: canceled, change: '-2%', isPositive: false, icon: XCircle, color: 'text-red-500' },
//     ];
//   }, [allOrders]);

//   // --- 3. Master Filtering Logic ---
//   useEffect(() => {
//     let result = [...allOrders];

//     // A. Tab Filter (Payment Status)
//     if (activeTab !== 'All') {
//       const statusMap = {
//         'Completed': 'PAID',
//         'Pending': 'PAYMENT_PENDING',
//         'Canceled': 'FAILED'
//       };
//       result = result.filter(order => order.status === statusMap[activeTab]);
//     }

//     // E. SORT
//     if (sortOrder === "newest") {
//       result.sort(
//         (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//       );
//     }

//     if (sortOrder === "oldest") {
//       result.sort(
//         (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
//       );
//     }

//     // B. Dropdown Filter (Fulfillment Status - NEW 🔥)
//     if (orderStatus) {
//        result = result.filter(order => {
//           // Checking against 'orderStatus' field or fallback to 'status'
//           const currentStatus = order.orderStatus || order.status || "";
//           return currentStatus.toLowerCase() === orderStatus.toLowerCase();
//        });
//     }

//     // C. Date Range Filter
//     if (fromDate) {
//         const from = new Date(fromDate).setHours(0, 0, 0, 0);
//         result = result.filter(order => new Date(order.createdAt).setHours(0,0,0,0) >= from);
//     }
//     if (toDate) {
//         const to = new Date(toDate).setHours(23, 59, 59, 999);
//         result = result.filter(order => new Date(order.createdAt).getTime() <= to);
//     }

//     // D. Search Filter
//     if (searchQuery) {
//       const lowerQuery = searchQuery.toLowerCase();
//       result = result.filter(order => 
//         (order.razorpayOrderId && order.razorpayOrderId.toLowerCase().includes(lowerQuery)) ||
//         (order.customerInfo?.name && order.customerInfo.name.toLowerCase().includes(lowerQuery)) ||
//         order.totalAmount.toString().includes(lowerQuery)
//       );
//     }

//     setFilteredOrders(result);
//     setCurrentPage(1); 
//   }, [allOrders, activeTab, searchQuery, fromDate, toDate, orderStatus, sortOrder]);

//   // --- 4. Pagination Slice ---
//   useEffect(() => {
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     setCurrentOrders(filteredOrders.slice(indexOfFirstItem, indexOfLastItem));
//   }, [filteredOrders, currentPage, itemsPerPage]);

//   // --- Helpers ---
//   const formatPrice = (price) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";

//     const date = new Date(dateString);

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };
  
//   const getStatusConfig = (status) => {
//     switch (status) {
//       case 'PAID': return { label: 'Paid', color: 'text-green-600', bg: 'bg-green-100', icon: CheckCircle };
//       case 'PAYMENT_PENDING': return { label: 'Unpaid', color: 'text-orange-600', bg: 'bg-orange-100', icon: Box };
//       case 'FAILED': return { label: 'Failed', color: 'text-red-600', bg: 'bg-red-100', icon: XCircle };
//       default: return { label: status, color: 'text-gray-600', bg: 'bg-gray-100', icon: Box };
//     }
//   };

//   const handlePageChange = (page) => {
//     if (typeof page !== "number") return; // 🔥 SAFETY
//     setCurrentPage(page);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };



//   return (
//     <div className="min-h-screen">
      
//       {/* HEADER */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
//         {showStats && <h1 className="text-2xl font-bold text-gray-800">Order List</h1>}
//       </div>

//       {/* STATS CARDS (Dynamic) */}
//       {showStats && <OrderStatsCard stats={stats} />}

//       {/* ================= FILTER SECTION ================= */}
//       <div className="flex flex-col gap-4 mb-6">

//         {/* TOP BAR */}
//         <div className="flex flex-col lg:flex-row justify-between gap-4">

//           {/* LEFT – TABS */}
//           <div className="flex bg-gray-100 p-1 rounded-xl w-fit">
//             {["All", "Completed", "Pending", "Canceled"].map(tab => (
//               <button
//                 key={tab}
//                 onClick={() => setActiveTab(tab)}
//                 className={`px-4 py-2 text-sm font-medium rounded-lg transition
//                   ${activeTab === tab
//                     ? "bg-white shadow text-blue-600"
//                     : "text-gray-500 hover:text-gray-700"}`}
//               >
//                 {tab}
//                 {tab === "All" && (
//                   <span className="ml-1 text-xs text-blue-600">
//                     ({filteredOrders.length})
//                   </span>
//                 )}
//               </button>
//             ))}
//           </div>

//           {/* RIGHT – SEARCH + ICONS */}
//           <div
//             ref={filterWrapperRef}
//             className="flex items-center gap-2 relative"
//           >

//             {/* SEARCH */}
//             <div className="relative w-64">
//               <Search
//                 size={16}
//                 className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
//               />
//               <input
//                 type="text"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 placeholder="Search order report"
//                 className="w-full pl-9 pr-3 py-2 bg-gray-100 border border-gray-200 rounded-md text-sm focus:outline-none"
//               />
//             </div>

//             {/* FILTER ICON */}
//             <button
//               onClick={() => {
//                 setShowFilter(!showFilter);
//                 setShowSort(false);
//                 setShowPageModal(false);
//               }}
//               className="p-2 border rounded-md hover:bg-gray-100"
//             >
//               <ListFilter size={20}/>
//             </button>

//             {/* SORT ICON */}
//             <button
//               onClick={() => {
//                 setShowSort(!showSort);
//                 setShowFilter(false);
//                 setShowPageModal(false);
//               }}
//               className="p-2 border rounded-md hover:bg-gray-100"
//             >
//               <RiArrowUpDownLine size={20}/>
//             </button>

//             {/* 3 DOT ICON */}
//             <button
//               onClick={() => {
//                 setShowPageModal(!showPageModal);
//                 setShowFilter(false);
//                 setShowSort(false);
//               }}
//               className="p-2 border rounded-md hover:bg-gray-100"
//             >
//               <FiMoreHorizontal size={20}/>
//             </button>

//             {/* ================= FILTER DROPDOWN ================= */}
//             {showFilter && (
//                 <div className="
//                   absolute right-0 top-12 w-72 bg-white border rounded-xl shadow-lg p-4 z-50
//                   origin-top-right animate-dropdown
//                 ">

//                 <p className="text-sm font-semibold">Filters</p>

//                 <SelectDropdown
//                   placeholder="Order Status"
//                   options={orderStatusOptions}
//                   value={orderStatus}
//                   onChange={(val) => {
//                     setOrderStatus(val);
//                     setCurrentPage(1);
//                   }}
//                 />

//                 <CustomDatePicker
//                   placeholder="From date"
//                   value={fromDate}
//                   onChange={(date) => {
//                     setFromDate(date);
//                     setCurrentPage(1);
//                   }}
//                 />

//                 <CustomDatePicker
//                   placeholder="To date"
//                   value={toDate}
//                   onChange={(date) => {
//                     setToDate(date);
//                     setCurrentPage(1);
//                   }}
//                 />

//                 <button
//                   onClick={() => {
//                     setOrderStatus("");
//                     setFromDate("");
//                     setToDate("");
//                   }}
//                   className="w-full text-sm text-red-600 border border-red-200 py-2 rounded-lg hover:bg-red-50"
//                 >
//                   Reset filters
//                 </button>
//               </div>
//             )}

//             {/* ================= SORT DROPDOWN ================= */}
//             {showSort && (
//               <div className="absolute right-0 top-12 w-48 bg-white border rounded-xl shadow-lg p-2 z-50">
//                 {sortOptions.map(opt => (
//                   <button
//                     key={opt.id}
//                     onClick={() => {
//                       setSortOrder(opt.id);
//                       setShowSort(false);
//                     }}
//                     className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded"
//                   >
//                     {opt.label}
//                   </button>
//                 ))}
//               </div>
//             )}

//             {/* ================= PAGE SIZE MODAL ================= */}
//             {showPageModal && (
//               <div className="absolute right-0 top-12 w-44 bg-white border rounded-xl shadow-lg p-2 z-50">
//                 {[10, 25, 50, 100].map(n => (
//                   <button
//                     key={n}
//                     onClick={() => {
//                       setItemsPerPage(n);
//                       setCurrentPage(1);
//                       setShowPageModal(false);
//                     }}
//                     className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded"
//                   >
//                     {n} per page
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       {/* ================= END FILTER SECTION ================= */}



//       {/* DATA TABLE */}
//       <OrderTable
//         loading={loading}
//         currentOrders={currentOrders}
//         currentPage={currentPage}
//         itemsPerPage={itemsPerPage}
//         formatDate={formatDate}
//         formatPrice={formatPrice}
//         getStatusConfig={getStatusConfig}
//       />

//       <Pagination
//         totalItems={filteredOrders.length}
//         itemsPerPage={itemsPerPage}
//         currentPage={currentPage}
//         onPageChange={handlePageChange}
//       />
//     </div>
//   );
// };

// export default AllOrder;


import React, { useEffect, useState, useMemo, useRef } from 'react';
import { 
  Clock,
  Box, 
  CheckCircle, 
  XCircle, 
  Search, 
  ListFilter,
  CalendarDays
} from 'lucide-react';
import Pagination from '../helpers/Pagination';
import summaryApi from '../common/SummaryApi'; 
import api from '../common/apiClient';
import OrderTable from "../panelComponents/AllOrderComponent/OrderTable";
import OrderStatsCard from '../panelComponents/AllOrderComponent/OrderStatCard';
import SelectDropdown from '../customStyles/SelectDropdown';
import CustomDatePicker from '../customStyles/CustomDatePicker';
import { RiArrowUpDownLine } from "react-icons/ri";
import { FiMoreHorizontal } from "react-icons/fi";

const AllOrder = ({showStats = true}) => {
  // --- State Management ---
  const [allOrders, setAllOrders] = useState([]); 
  const [filteredOrders, setFilteredOrders] = useState([]); 
  const [currentOrders, setCurrentOrders] = useState([]);  
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [showPageModal, setShowPageModal] = useState(false);
  const [orderStatus, setOrderStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [sortOrder, setSortOrder] = useState(""); // newest | oldest
  const filterWrapperRef = useRef(null);
  
  // --- FILTERS STATE ---
  const [activeTab, setActiveTab] = useState('All'); // Based on paymentStatus
  const [searchQuery, setSearchQuery] = useState('');

  const orderStatusOptions = [
    { id: "", label: "All Status" },
    { id: "ordered", label: "Ordered" },
    { id: "packaged", label: "Packaged" },
    { id: "shipped", label: "Shipped" },
    { id: "delivered", label: "Delivered" },
    { id: "cancelled", label: "Cancelled" },
    { id: "returnRequested", label: "Return Requested" },
    { id: "returnAccepted", label: "Return Accepted" },
    { id: "returned", label: "Returned" },
  ];

  const sortOptions = [
    { id: "newest", label: "Newest first" },
    { id: "oldest", label: "Oldest first" },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(e.target)
      ) {
        setShowFilter(false);
        setShowSort(false);
        setShowPageModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  // --- 1. Fetch Data ---
  const fetchAllOrders = async () => {
    try {
      setLoading(true);
      const response = await api({
        url: summaryApi.getAllOrders.url,
        method: summaryApi.getAllOrders.method,
        params: {
          page: 1,
          limit: 5000, 
        },
        withCredentials: true
      });

      if (response.data.success) {
        setAllOrders(response.data.orders);
        setFilteredOrders(response.data.orders);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllOrders();
  }, []);

  // --- 2. Stats Calculation ---
  const stats = useMemo(() => {
    const total = allOrders.length;
    
    // TODAY ORDERS LOGIC
    const today = new Date().setHours(0,0,0,0);
    const todayCount = allOrders.filter(o => new Date(o.createdAt).setHours(0,0,0,0) === today).length;

    const completed = allOrders.filter(o => o.paymentStatus === 'PAID').length;
    const canceled = allOrders.filter(o => o.status === 'cancelled').length;

    return [
      { title: 'Total Orders', value: total, change: 'All time', isPositive: true, icon: Box, color: 'text-blue-600' },
      { title: "Today's Orders", value: todayCount, change: 'Today', isPositive: true, icon: CalendarDays, color: 'text-orange-500' },
      { title: 'Paid Orders', value: completed, change: 'Payment Success', isPositive: true, icon: CheckCircle, color: 'text-green-600' },
      { title: 'Cancelled', value: canceled, change: 'Fulfillment', isPositive: false, icon: XCircle, color: 'text-red-500' },
    ];
  }, [allOrders]);

  // --- 3. Master Filtering Logic ---
  useEffect(() => {
    let result = [...allOrders];

    // A. Tab Filter (Payment Status - mapping your PAID/PAYMENT_PENDING)
    if (activeTab !== 'All') {
      const statusMap = {
        'Completed': 'PAID',
        'Pending': 'PENDING',
        'Canceled': 'FAILED'
      };
      result = result.filter(order => order.paymentStatus?.toLowerCase() === statusMap[activeTab]?.toLowerCase());
    }

    // B. Fulfillment Dropdown Filter
    if (orderStatus) {
       result = result.filter(order => order.status === orderStatus);
    }

    // C. Date Range Filter
    if (fromDate) {
        const from = new Date(fromDate).setHours(0, 0, 0, 0);
        result = result.filter(order => new Date(order.createdAt).setHours(0,0,0,0) >= from);
    }
    if (toDate) {
        const to = new Date(toDate).setHours(23, 59, 59, 999);
        result = result.filter(order => new Date(order.createdAt).getTime() <= to);
    }

    // D. Search Filter
    if (searchQuery) {
      const lowerQuery = searchQuery.toLowerCase();
      result = result.filter(order => 
        (order.razorpayOrderId && order.razorpayOrderId.toLowerCase().includes(lowerQuery)) ||
        (order.customerInfo?.name && order.customerInfo.name.toLowerCase().includes(lowerQuery)) ||
        (order._id && order._id.toLowerCase().includes(lowerQuery)) ||
        order.totalAmount.toString().includes(lowerQuery)
      );
    }

    // E. SORT
    if (sortOrder === "newest") {
      result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (sortOrder === "oldest") {
      result.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    }

    setFilteredOrders(result);
    setCurrentPage(1); 
  }, [allOrders, activeTab, searchQuery, fromDate, toDate, orderStatus, sortOrder]);

  // --- 4. Pagination Slice ---
  useEffect(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentOrders(filteredOrders.slice(indexOfFirstItem, indexOfLastItem));
  }, [filteredOrders, currentPage, itemsPerPage]);

  const formatPrice = (price) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);
  
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  
  // Mapping for Payment Status badges
  const getPaymentConfig = (status) => {
    switch (status) {
      case 'PAID': return { label: 'Paid', color: 'text-green-600', bg: 'bg-green-100', icon: CheckCircle };
      case 'PENDING': return { label: 'Unpaid', color: 'text-orange-600', bg: 'bg-orange-100', icon: Clock };
      case 'FAILED': return { label: 'Failed', color: 'text-red-600', bg: 'bg-red-100', icon: XCircle };
      default: return { label: status, color: 'text-gray-600', bg: 'bg-gray-100', icon: Box };
    }
  };

  // Mapping for Fulfillment Status badges
  const getFulfillmentConfig = (status) => {
    const base = "px-2 py-1 text-[10px] font-bold rounded uppercase tracking-wider ";
    switch (status) {
      case 'delivered': return base + "bg-green-50 text-green-700 border border-green-200";
      case 'cancelled': return base + "bg-red-50 text-red-700 border border-red-200";
      case 'shipped': return base + "bg-blue-50 text-blue-700 border border-blue-200";
      case 'packaged': return base + "bg-purple-50 text-purple-700 border border-purple-200";
      default: return base + "bg-gray-50 text-gray-700 border border-gray-200";
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        {showStats && <h1 className="text-2xl font-bold text-gray-800">Order Management</h1>}
      </div>

      {showStats && <OrderStatsCard stats={stats} />}

      <div className="flex flex-col gap-4 mb-6">
        <div className="flex flex-col lg:flex-row justify-between gap-4">
          <div className="flex bg-gray-100 p-1 rounded-xl w-fit">
            {["All", "Completed", "Pending"].map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition
                  ${activeTab === tab ? "bg-white shadow text-blue-600" : "text-gray-500 hover:text-gray-700"}`}
              >
                {tab} {tab === "All" && <span className="ml-1 text-xs">({filteredOrders.length})</span>}
              </button>
            ))}
          </div>

          <div ref={filterWrapperRef} className="flex items-center gap-2 relative">
            <div className="relative w-64">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search ID, Customer, Amount..."
                className="w-full pl-9 pr-3 py-2 bg-gray-100 border border-gray-200 rounded-md text-sm focus:outline-none"
              />
            </div>

            <button onClick={() => { setShowFilter(!showFilter); setShowSort(false); setShowPageModal(false); }} className="p-2 border rounded-md hover:bg-gray-100"><ListFilter size={20}/></button>
            <button onClick={() => { setShowSort(!showSort); setShowFilter(false); setShowPageModal(false); }} className="p-2 border rounded-md hover:bg-gray-100"><RiArrowUpDownLine size={20}/></button>
            <button onClick={() => { setShowPageModal(!showPageModal); setShowFilter(false); setShowSort(false); }} className="p-2 border rounded-md hover:bg-gray-100"><FiMoreHorizontal size={20}/></button>

            {showFilter && (
                <div className="absolute right-0 top-12 w-72 bg-white border rounded-xl shadow-lg p-4 z-50 animate-dropdown">
                <p className="text-sm font-semibold mb-2">Order Filters</p>
                <SelectDropdown placeholder="Fulfillment Status" options={orderStatusOptions} value={orderStatus} onChange={(val) => { setOrderStatus(val); setCurrentPage(1); }} />
                <CustomDatePicker placeholder="From date" value={fromDate} onChange={(date) => { setFromDate(date); setCurrentPage(1); }} />
                <CustomDatePicker placeholder="To date" value={toDate} onChange={(date) => { setToDate(date); setCurrentPage(1); }} />
                <button onClick={() => { setOrderStatus(""); setFromDate(""); setToDate(""); }} className="w-full text-sm text-red-600 border border-red-200 py-2 rounded-lg hover:bg-red-50 mt-2">Reset</button>
              </div>
            )}

            {showSort && (
              <div className="absolute right-0 top-12 w-48 bg-white border rounded-xl shadow-lg p-2 z-50">
                {sortOptions.map(opt => (
                  <button key={opt.id} onClick={() => { setSortOrder(opt.id); setShowSort(false); }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded">{opt.label}</button>
                ))}
              </div>
            )}

            {showPageModal && (
              <div className="absolute right-0 top-12 w-44 bg-white border rounded-xl shadow-lg p-2 z-50">
                {[10, 25, 50, 100].map(n => (
                  <button key={n} onClick={() => { setItemsPerPage(n); setCurrentPage(1); setShowPageModal(false); }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded">{n} per page</button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <OrderTable
        loading={loading}
        currentOrders={currentOrders}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        formatDate={formatDate}
        formatPrice={formatPrice}
        getPaymentConfig={getPaymentConfig}
        getFulfillmentConfig={getFulfillmentConfig}
      />

      <Pagination
        totalItems={filteredOrders.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default AllOrder;